import { render, staticRenderFns } from "./ClinicalPreferences.vue?vue&type=template&id=1f0def2a&scoped=true"
import script from "./ClinicalPreferences.vue?vue&type=script&lang=js"
export * from "./ClinicalPreferences.vue?vue&type=script&lang=js"
import style0 from "./ClinicalPreferences.vue?vue&type=style&index=0&id=1f0def2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0def2a",
  null
  
)

export default component.exports